/* eslint-disable no-console */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import {
  Button,
  Icon,
  Loading,
  Pane,
  Paneset,
} from '@folio/stripes-components';
import { CalloutContext, useOkapiKy } from '@folio/stripes-core';
import CustomFieldsView from './components/CustomFieldsView';
import useCustomFields from '../../../hooks/useCustomFields';
import ActionsMenu from '../../../shared/ActionsMenu/ActionsMenu';

function CustomFieldsSettings({ basePath }) {
  const { customFields, isLoading, refetch } = useCustomFields();

  const okapiKy = useOkapiKy();
  const context = useContext(CalloutContext);

  const onCreate = (item) => {
    okapiKy
      .post('inventory-customFields', {
        timeout: 30000,
        method: 'POST',
        json: item,
      })
      .json()
      .then((res) => {
        if (res.id) {
          const message = (
            <FormattedMessage
              id="ui-plugin-inventory-templates.customFieldsForm.callout.create"
              defaultMessage="Custom field created successfully"
            />
          );
          context.sendCallout({ message });
          refetch();
        }
      })
      .catch(async (err) => {
        console.log(err);
        const res = err.response;
        const text = await res.text();
        console.log(text);
        context.sendCallout({ message: text, type: 'error' });
      });
  };

  const onUpdate = (item) => {
    okapiKy
      .put(`inventory-customFields/${item.id}`, {
        timeout: 30000,
        method: 'PUT',
        headers: {
          'content-Type': 'application/json',
          accept: 'text/plain',
        },
        json: item,
      })
      .json()
      .then(() => {
        const message = (
          <FormattedMessage
            id="ui-plugin-inventory-templates.customFieldsForm.callout.updated"
            defaultMessage="Custom field updated successfully"
          />
        );
        context.sendCallout({ message });
        refetch();
      })
      .catch(async (err) => {
        const res = err.response;
        const text = await res.text();
        console.log('error: ', text);
        context.sendCallout({ message: text, type: 'error' });
      });
  };

  return (
    <Paneset>
      <Pane
        id="inventory-plugin-template-customFields-list-pane"
        paneTitle={
          <FormattedMessage
            id="ui-plugin-inventory-templates.customFields.pane.paneTitle"
            defaultMessage="Inventory custom fields"
          />
        }
        fluidContentWidth
        centeredContent
        lastMenu={
          <>
            <Button
              id="customFields-list-pane-lastMenu-new-field-btn"
              buttonStyle="primary"
              marginBottom0
              to={`${basePath}/customfields/create`}
            >
              <Icon icon="plus-sign">
                <FormattedMessage
                  id="ui-plugin-inventory-templates.customFields.buttons.createNew.field"
                  defaultMessage="New field"
                />
              </Icon>
            </Button>
            <Button
              id="customFields-list-pane-lastMenu-new-category-btn"
              buttonStyle="primary"
              marginBottom0
              to={`${basePath}/category/create`}
            >
              <Icon icon="plus-sign">
                <FormattedMessage
                  id="ui-plugin-inventory-templates.customFields.buttons.createNew.category"
                  defaultMessage="New category"
                />
              </Icon>
            </Button>
            <ActionsMenu
              contentData={customFields}
              fileName={
                <FormattedMessage
                  id="ui-plugin-inventory-templates.customFields.pane.paneTitle"
                  defaultMessage="Inventory custom fields"
                />
              }
              permissions={{
                export:
                  'ui-plugin-inventory-templates.inventoryTemplates.export',
                import:
                  'ui-plugin-inventory-templates.inventoryTemplates.import',
              }}
              onCreate={onCreate}
              onUpdate={onUpdate}
              primaryField="name"
              visibleFields={[]}
              dataFormat="pre"
              columnMapping={{}}
            />
          </>
        }
      >
        {isLoading && <Loading size="large" />}
        {!isLoading && customFields?.length && (
          <CustomFieldsView
            inventoryCustomFields={customFields}
            basePath={basePath}
            refetch={refetch}
          />
        )}
      </Pane>
    </Paneset>
  );
}

CustomFieldsSettings.propTypes = {
  basePath: PropTypes.string,
};

export default CustomFieldsSettings;
